import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  // Close on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-220">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-221">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-navy-900/80 backdrop-blur-sm" data-id="element-222" />

          {/* Modal Content */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative w-full max-w-3xl bg-cream-50 rounded-2xl shadow-2xl overflow-hidden max-h-[85vh] flex flex-col" data-id="element-223">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-cream-200 bg-white" data-id="element-224">
              <h2 className="text-2xl font-serif font-bold text-navy-900" data-id="element-225">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 text-navy-500 hover:text-navy-900 hover:bg-cream-100 rounded-full transition-colors" aria-label="Cerrar" data-id="element-226">
                <X className="h-6 w-6" data-id="element-227" />
              </button>
            </div>

            {/* Scrollable Body */}
            <div className="p-6 md:p-8 overflow-y-auto font-body text-navy-800 leading-relaxed space-y-4" data-id="element-228">
              {children}
            </div>

            {/* Footer */}
            <div className="p-4 border-t border-cream-200 bg-cream-100 flex justify-end" data-id="element-229">
              <button onClick={onClose} className="px-6 py-2 bg-navy-900 text-cream-100 rounded-lg hover:bg-navy-800 transition-colors font-bold text-sm" data-id="element-230">
                Cerrar
              </button>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}